import { useRef } from "react";
import { scrollToHelper } from "../shared/helpers/scrollToHelper";

const WAIT_UNTIL_COMPONENT_IS_LOADED = 50;

export const useScrollToProduct = () => {
  const refGrappleModules = useRef(undefined);
  const refLowerBrackets = useRef(undefined);
  const refMachineFixingList = useRef(undefined);
  const refMachineFixings = useRef(undefined);
  const refMachineFixingsProduct = useRef(undefined);
  const refTiltrotators = useRef(undefined);
  const refToolsItems = useRef(undefined);
  const refToolsProduct = useRef(undefined);
  const refToolsProductItemsList = useRef(undefined);
  const refUpperBrackets = useRef(undefined);

  const scrollToToolsList = () => {
    setTimeout(() => {
      if (refToolsItems.current) {
        refToolsItems.current.scrollIntoView(scrollToHelper.options);
      }
    }, WAIT_UNTIL_COMPONENT_IS_LOADED);
  };

  const scrollToToolsProductItemsList = () => {
    setTimeout(() => {
      if (refToolsProductItemsList.current) {
        refToolsProductItemsList.current.scrollIntoView(scrollToHelper.options);
      }
    }, WAIT_UNTIL_COMPONENT_IS_LOADED);
  };

  const scrollToGrappleModules = () => {
    setTimeout(() => {
      if (refGrappleModules.current) {
        refGrappleModules.current.scrollIntoView(scrollToHelper.options);
      }
    }, WAIT_UNTIL_COMPONENT_IS_LOADED);
  };

  const scrollToLowerBrackets = () => {
    setTimeout(() => {
      if (refLowerBrackets.current) {
        refLowerBrackets.current.scrollIntoView(scrollToHelper.options);
      }
    }, WAIT_UNTIL_COMPONENT_IS_LOADED);
  };

  const scrollToMachineFixings = () => {
    setTimeout(() => {
      if (refMachineFixingList.current) {
        refMachineFixingList.current.scrollIntoView(scrollToHelper.options);
      }
    }, WAIT_UNTIL_COMPONENT_IS_LOADED);
  };

  const scrollToMachineFixingsProduct = () => {
    setTimeout(() => {
      if (refMachineFixingsProduct.current) {
        refMachineFixingsProduct.current.scrollIntoView(scrollToHelper.options);
      }
    }, WAIT_UNTIL_COMPONENT_IS_LOADED);
  };

  const scrollToTiltrotators = () => {
    setTimeout(() => {
      if (refTiltrotators.current) {
        refTiltrotators.current.scrollIntoView(scrollToHelper.options);
      }
    }, WAIT_UNTIL_COMPONENT_IS_LOADED);
  };

  const scrollToToolsProduct = () => {
    setTimeout(() => {
      if (refToolsProduct.current) {
        refToolsProduct.current.scrollIntoView(scrollToHelper.options);
      }
    }, WAIT_UNTIL_COMPONENT_IS_LOADED);
  };

  const scrollToUpperBrackets = () => {
    setTimeout(() => {
      if (refUpperBrackets.current) {
        refUpperBrackets.current.scrollIntoView(scrollToHelper.options);
      }
    }, WAIT_UNTIL_COMPONENT_IS_LOADED);
  };
  return {
    refGrappleModules,
    refLowerBrackets,
    refMachineFixingList,
    refMachineFixings,
    refMachineFixingsProduct,
    refTiltrotators,
    refToolsProduct,
    refToolsProductItemsList,
    refUpperBrackets,
    refToolsItems,
    scrollToGrappleModules,
    scrollToLowerBrackets,
    scrollToMachineFixings,
    scrollToMachineFixingsProduct,
    scrollToTiltrotators,
    scrollToToolsProduct,
    scrollToToolsProductItemsList,
    scrollToUpperBrackets,
    scrollToToolsList,
  };
};
